import { defineStore } from "pinia";
import { getFaqs, getFaqsFooter } from "@/api/auth";

export const useFaqsStore = defineStore("faqs", {
  state: () => ({
    faqs: [],
    faqsFooter: [],
    firstcall: true,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchFaqs(isClient) {
      if (this.firstcall) this.loading = true;
      try {
        getFaqs(isClient)
          .then(response => {
            console.log(response.data, "faqs");
            this.faqs = response.data;
            if (this.firstcall) {
              this.firstcall = false;
              this.loading = false;
            }
          })
          .catch(() => {});
      } catch {
        this.error = "Erreur lors du chargement des faq";
      }
    },
    async fetchFaqsFooter(isClient) {
      if (this.firstcall) this.loading = true;
      try {
        getFaqsFooter(isClient)
          .then(response => {
            this.faqsFooter = response.data;
            if (this.firstcall) {
              this.firstcall = false;
              this.loading = false;
            }
          })
          .catch(() => {});
      } catch {
        this.error = "Erreur lors du chargement des faq";
      }
    },
  },
  persist: true,
});
